import { render, staticRenderFns } from "./bind-wx-subuser.vue?vue&type=template&id=529929a9&"
import script from "./bind-wx-subuser.vue?vue&type=script&lang=js&"
export * from "./bind-wx-subuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports